/* template */
<template minapp="mpx" xlang="wxml"><div :class="(isNameClass)" class="es-content__name-cell" v-if="(isShow || isRequired)"><div class="es-content__name"><div class="es-content__name-box"><span class="es-content__required-text" v-if="(isRequired && isRequiredShow)">*</span><div>{{label}}</div></div><div class="es-content__foreigner">{{sub_label}}</div></div><div class="es-content__name-text" v-if="(!isDisable)"><div class="es-content__name-field"><slot name="input"></slot></div><div class="es-content__name-text-tips">{{ nameTips }}</div></div><div class="es-content__name-text-disable" v-else>{{ innerValue }}</div><div :class="(isBorderClass)" class="es-content__name-text-border"></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m141a5554"}'>
  +b('content')
    +e('name')  
      display flex
      flex-direction column
      justify-content center
      width 80px
      height 34px
      font-family PingFangSC-Regular
      font-size 14px
      letter-spacing 0
      margin-right 32px
      color #333333
    +e('name-box')
      display flex
    +e('required-text')
      color #F93822
    +e('miniapp_cell')
      height 54px
      color #333333
      padding 10px 0 !important
      &::after
        border-bottom 1px solid #f0f2f7
        left 76px
        right 0
    +e('foreigner')
      font-size 12px
      line-height 1
      color #999999
      transform scale(0.83)
      margin-left -4px
    +e('name-cell')
      position relative
      display flex
      min-height 34px
      color #333333
      padding 10px 0
    +e('name-field')
      display flex
      align-items center
      height 34px
    +e('name-text-border')
      position absolute
      bottom 0
      right 0
      height 1px
      width calc(100% - 90px)
      background: rgba(240,242,247,1);
      transform: scaleY(0.5);
    +e('red-border')
      background: rgba(221,8,11,0.5)
    +e('disable')
      color #bbbbbb !important
      background-color #ffffff
      /deep/ .es-field__body
        color #bbbbbb !important
        background-color #ffffff !important
        opacity 1 !important
    +e('no-padding')
      padding-bottom 0px
      margin-bottom 10px
    +e('name-text')
      width calc(100% - 80px)
      position relative
      display flex
      flex-direction column
      font-family PingFangSC-Regular
      font-size 14px
      color #333333
    +e('name-text-tips')
      // position absolute
      top 18px
      color #DD080B
      font-size 11px
      display flex
    +e('name-text-disable')
      line-height 34px
      font-size 14px
      overflow hidden
    +e('input')
      width calc(100% - 6px)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m141a5554"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./from-item.mpx.js?isComponent&outputPath=components%2Ffrom-item141a5554%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./from-item.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Ffrom-item141a5554%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m141a5554"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/from-item141a5554/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'es-cell':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/cell/index.mpx?isComponent&outputPath=components%2Findex1902b88c%2Findex")),'es-field':getComponent(require("../../../../../../node_modules/@didi/es-mpx-ui/lib/field/index.mpx?isComponent&outputPath=components%2Findex69975464%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
